<template>
  <div class="tuolele-main-box store-setting">
    <div class="tuolele-main-search">
      <el-row type="flex" justify="space-between">
        <el-form :inline="true" :model="search">
          <el-form-item label="店铺搜索">
            <el-input
              v-model="search.name"
              clearable
              placeholder="请输入店铺名称"
              @keyup.enter.native="handleEnterSearch"
            />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              class="el-button-confirm"
              @click="getShopList"
            >查询</el-button>
          </el-form-item>
        </el-form>
        <div>
          <el-button
            type="primary"
            @click="editStore('add')"
          >新增店铺</el-button>
          <el-button type="success" @click="exportExcel">导出Excel表</el-button>
        </div>
      </el-row>
    </div>
    <div class="tuolele-main-content">
      <el-table :key="tableShopKey" :data="tableData" border stripe>
        <el-table-column prop="id" label="店铺ID" />
        <el-table-column prop="name" label="店铺名称" />
        <!-- <el-table-column prop="province_name" label="所属省份" /> -->
        <!-- <el-table-column prop="city_name" label="所属城市" /> -->
        <el-table-column prop="area_name" label="所属区/县" />
        <el-table-column prop="address" label="详细地址" />
        <!-- <el-table-column prop="telephone" label="咨询电话">
        <template slot-scope="scope">
          <span>{{ scope.row.extra.telephone }}</span>
        </template>
        </el-table-column> -->
        <el-table-column prop="school_count" label="覆盖小学">
          <template slot-scope="scope">
            <span>{{ scope.row.school_count || "0" }}所</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="local_url" label="NAS">
          <template slot-scope="scope">
            <p>{{ scope.row.extra.local_url }}</p>
            <p>{{ scope.row.extra.version }}</p>
          </template>
        </el-table-column> -->
        <el-table-column v-if="uid == 958" prop="version" label="大屏店铺">
          <template slot-scope="scope">
            <span>{{ (scope.row.extra.screen_identity_info && scope.row.extra.screen_identity_info.schoolName) || "未配置" }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="modify_time" label="更新时间" /> -->
        <!-- <el-table-column prop="connect_status" label="连接状态">
          <template slot-scope="scope">
            <strong :class="scope.row.connect_status == '1' ? 'green-font-color' : 'danger-font-color'" v-text="scope.row.connect_status == '1' ? '连接中' : '未连接'" />
          </template>
        </el-table-column> -->
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-dropdown :hide-on-click="false" type="primary">
              <span class="el-dropdown-link">
                更多<i class="el-icon-arrow-down el-icon--right" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="getSchoolList(scope.row)">查看小学</el-dropdown-item>
                <el-dropdown-item @click.native="editStore('edit', scope.row)">编辑店铺</el-dropdown-item>
                <el-dropdown-item @click.native="editPrint(scope.row.id)">打印机配置</el-dropdown-item>
                <el-dropdown-item @click.native="fnEditFace(scope.row.id)">人脸识别配置</el-dropdown-item>
                <el-dropdown-item @click.native="fnEditFaceV3(scope.row)">V3 人脸设备</el-dropdown-item>
                <el-dropdown-item @click.native="fnUpdateScreen(scope.row.id, scope.row.extra.screen_identity_info ? scope.row.extra.screen_identity_info.schoolId : '')">配置大屏</el-dropdown-item>
                <el-dropdown-item @click.native="fnShowRoomManage(scope.row.id)">教室管理</el-dropdown-item>
                <el-dropdown-item @click.native="fnUpdateCorrectId(scope.row)">设置批改节点</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

    </div>
    <el-dialog title="覆盖小学名单" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
      <el-table :data="schoolData">
        <el-table-column property="school_name" label="学校名称" width="180px" />
        <el-table-column property="school_address" label="地址" />
        <el-table-column property="student_count" label="学员人数" />
        <el-table-column label="接校">
          <template slot-scope="scope">
            {{ scope.row.is_fetch === "0" ? "否" : "是" }}
          </template>
        </el-table-column>

      </el-table>
    </el-dialog>
    <el-dialog title="教室管理" :visible.sync="bShowRoomDialog" width="60%">
      <el-button type="success" @click="fnAddClassRoom()">添加教室</el-button>
      <el-table :key="tableRoomKey" :data="roomLists" style="margin-top: 20px;">
        <el-table-column property="name" label="教室名称" width="180px" />
        <el-table-column property="create_time" label="创建时间" />
        <el-table-column property="modify_time" label="修改时间" />
        <el-table-column property="summary" label="备注信息" />
        <!-- <el-table-column label="环境监测设备">
          <template slot-scope="scope">
            {{ scope.row.extra && scope.row.extra.point_position_info.officialName }}
          </template>
        </el-table-column> -->
        <el-table-column property="teacher_count" label="班主任人数" />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- <el-button type="text" size="mini" @click="fnConfigAIOT(scope.row.shop_id,scope.row.id)">配置环境监测</el-button> -->
            <el-button type="warning" size="mini" class="" @click="fnAddClassRoom(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="fnDeleteRoomAct(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="添加/编辑教室" :visible.sync="bShowAddClass" width="30%">
      <el-form ref="addRoomPostForm" :model="addRoomPostForm" :rules="addRoomPostFormRule" label-width="80px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="addRoomPostForm.name" placeholder="输入教室名称" />
        </el-form-item>
        <el-form-item label="备注" prop="summary">
          <el-input v-model="addRoomPostForm.summary" placeholder="输入备注信息" />
        </el-form-item>
      </el-form>
      <div style="float: right;margin-bottom: 20px;margin-right: 20px;">
        <el-button type="primary" :loading="bCreateRoomLoading" @click="sumbitCreateRoom">确定</el-button>
        <el-button @click="bShowAddClass = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="配置大屏" :visible.sync="bShowDeivceMangeDialog" width="30%">
      <DeviceStoreMange :key="dialogScreenKey" :shop-id="currentShopId" :school-id="currentSchoolId" @successCBK="getShopList()" />
    </el-dialog>
    <el-dialog title="人脸识别" :visible.sync="bShowFaceDeivceMangeDialog" width="40%">
      <FaceDeviceMange :key="dialogScreenKey" :shop-id="currentShopId" @successCBK="getShopList()" />
    </el-dialog>
    <el-dialog title="V3 人脸设备管理" :visible.sync="bShowFaceV3Dialog" width="86%" top="4vh">
      <FaceDeviceV3Manage v-if="bShowFaceV3Dialog" :key="faceV3DialogKey" :shop-id="currentShopId" :shop-name="currentShopName" />
    </el-dialog>
    <el-dialog title="配置环境监测" :visible.sync="bShowAIOTDialog" width="30%">
      <el-form :inline="true" :model="search">
        <el-form-item label="绑定店铺">
          <Select key="4" :selected.sync="aiotPostForm.deviceId" :data="aiotLists" clearable placeholder="请选择状态" />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            class="el-button-confirm"
            @click="fnBindDevice()"
          >绑定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="打印机配置" :visible.sync="bShowSettingPrintDialog" width="600px">
      <el-form :model="printPostForm" label-width="120px">
        <el-form-item label="设备ID">
          <el-input v-model="printPostForm.device_id" placeholder="请输入设备ID" />
        </el-form-item>
        <el-form-item label="设备密钥">
          <el-input v-model="printPostForm.device_key" placeholder="请输入设备密钥" />
        </el-form-item>
        <el-form-item label="设备名称">
          <Select key="4" style="width:70%" :selected.sync="printPostForm.printer_name" :data="printLists" clearable placeholder="请选择状态" />
          <el-button type="primary" style="float:right" @click="getPrintList()">获取</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="el-button-confirm" @click="bindPrint()">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="批改节点配置" :visible.sync="bShowSetCorrectDialog" width="600px">
      <el-form :model="printPostForm" label-width="120px">
        <el-form-item label="节点ID">
          <el-input v-model="correctPostForm.node_id" placeholder="请输入设备ID" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="el-button-confirm" @click="fnConfirmCorrect()">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import Tool from '@/assets/js/tool.js'
import DeviceStoreMange from './components/DeviceStoreMange'
import FaceDeviceMange from './components/FaceDeviceManage'
import FaceDeviceV3Manage from './components/FaceDeviceV3Manage'
import Select from '@/components/Select'

const defaultPostForm = {
  shop_id: ''
}

const defaultPrintPostForm = {
  shop_id: '',
  device_id: '',
  device_key: '',
  printer_name: ''
}

const defaultAddRoomPostForm = {
  shop_id: '',
  name: '',
  summary: '',
  id: ''
}

export default {
  name: 'StoreSetting',
  components: {
    DeviceStoreMange,
    Select,
    FaceDeviceMange,
    FaceDeviceV3Manage
  },
  data() {
    return {
      search: {
        name: ''
      },
      aiotPostForm: {
        deviceId: '',
        school_room_id: ''
      },
      bShowSetCorrectDialog: false,
      correctPostForm: {
        shop_id: '',
        node_id: ''
      },
      printPostForm: Object.assign({}, defaultPrintPostForm),
      bShowAIOTDialog: false,
      bShowFaceDeivceMangeDialog: false,
      bShowFaceV3Dialog: false,
      faceV3DialogKey: 0,
      currentShopName: '',
      aiotLists: [],
      uid: 0,
      tableData: [],
      schoolData: [],
      dialogVisible: false,
      currentShopId: '',
      currentSchoolId: '',
      dialogScreenKey: '',
      bShowDeivceMangeDialog: false,
      bShowRoomDialog: false,
      bShowSettingPrintDialog: false,
      printLists: [],
      roomLists: [],
      tableRoomKey: 0,
      tableShopKey: 0,
      postForm: Object.assign({}, defaultPostForm),
      bShowAddClass: false,
      addRoomPostForm: Object.assign({}, defaultAddRoomPostForm),
      bCreateRoomLoading: false,
      addRoomPostFormRule: {
        name: [{ required: true, message: '请输入名称', trigger: 'change' }],
        summary: [{ required: true, message: '请输入备注', trigger: 'change' }]
      }
    }
  },

  mounted() {
    this.uid = JSON.parse(localStorage.getItem('userInfo')).uid
    this.getShopList()
  },
  methods: {
    getSchoolList(row) {
      this.dialogVisible = true
      this.$http.getSchoolList({ shop_id: row.id }).then(res => {
        this.tableShopKey++
        this.schoolData = res.data
      })
    },
    fnBindDevice() {
      const index = Tool.findIndexInArryByKeyVal(this.aiotLists, 'id', this.aiotPostForm.deviceId)
      if (index < 0) {
        return
      }
      const obj = this.aiotLists[index]
      obj.school_room_id = this.aiotPostForm.school_room_id
      this.$http.bindingPointPosition(obj).then(res => {
        this.$message({
          type: 'success',
          message: '绑定成功'
        })
        this.bShowAIOTDialog = false
        this.fnGetRoomList()
      })
    },
    fnConfigAIOT(shop_id, roomId) {
      this.$http.getPointPositionList({ shop_id }).then(res => {
        this.aiotPostForm.school_room_id = roomId;
        (res.data || []).forEach((ele) => {
          ele.id = ele.officialId
          ele.name = ele.officialName
        })
        this.aiotLists = res.data
        this.bShowAIOTDialog = true
      })
    },
    handleClose() {
      this.dialogVisible = false
    },
    fnShowRoomManage(shop_id) {
      this.bShowRoomDialog = true
      this.postForm.shop_id = shop_id
      this.fnGetRoomList()
    },
    sumbitCreateRoom() {
      this.$refs['addRoomPostForm'].validate((valid) => {
        if (valid) {
          this.bCreateRoomLoading = true
          this.$http.improveClassroomRoom(this.addRoomPostForm).then(res => {
            this.bCreateRoomLoading = false
            this.bShowAddClass = false
            this.$refs['addRoomPostForm'].resetFields()
            this.fnGetRoomList()
          })
        }
      })
    },
    fnInitFaceDeviceEvent(sn) {
      if (!sn) {
        this.$message({
          type: 'error',
          message: '请先配置'
        })
      }
      this.$confirm('是否确认初始化！', '确认重置', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        this.fnInitFace(sn)
      })
    },
    fnInitFace(sn) {
      this.$http.initializeDevice({ sn }).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '初始化成功'
          })
        }
      })
    },
    fnGetRoomList() {
      this.$http.getClassroomRoomList({ shop_id: this.postForm.shop_id }).then(res => {
        this.tableRoomKey++
        this.roomLists = res.data.list
      })
    },
    fnAddClassRoom(room) {
      if (room) {
        this.addRoomPostForm.id = room.id
        this.addRoomPostForm.name = room.name
        this.addRoomPostForm.summary = room.summary
      } else {
        this.addRoomPostForm.id = ''
        this.$refs['addRoomPostForm'] && this.$refs['addRoomPostForm'].resetFields()
      }
      this.addRoomPostForm.shop_id = this.postForm.shop_id
      this.bShowAddClass = true
    },
    fnDeleteRoomAct(room_id) {
      this.$confirm('确认删除后，教室内班主任将转为待绑定教室状态！', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        this.fnRemoveRoom(room_id)
      })
    },
    fnRemoveRoom(school_room_id) {
      this.$http.removeClassroomRoom({ school_room_id }).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.fnGetRoomList()
        }
      })
    },
    fnEditFace(id) {
      this.currentShopId = id
      this.dialogScreenKey++
      this.bShowFaceDeivceMangeDialog = true
      // this.$http.getShopValue({ key: 'face_sn', shopId: id }).then(res => {
      //   if (res.code == 200) {
      //     this.$prompt('请输入人脸识别设备号', '提示', {
      //       confirmButtonText: '确定',
      //       cancelButtonText: '取消',
      //       inputValue: res.data
      //     }).then(({ value }) => {
      //       this.$http.setShopValue({ key: 'face_sn', shopId: id, value: value }).then(res => {
      //         if (res.code == 200) {
      //           this.$message({
      //             type: 'success',
      //             message: '配置成功'
      //           })
      //         }
      //       })
      //     }).catch(() => {

      //     })
      //   }
      // })
    },
    fnEditFaceV3(row) {
      this.currentShopId = row.id
      this.currentShopName = row.name
      this.faceV3DialogKey++
      this.bShowFaceV3Dialog = true
    },
    editStore(type, row) {
      const id = row ? row.id : ''
      this.$router.push({
        path: 'storeAdd',
        query: { id: id, type: type }
      })
    },
    getShopList() {
      this.bShowDeivceMangeDialog = false
      this.$http.getShopList({ name: this.search.name }).then(res => {
        this.tableData = res.data
      })
    },
    fnUpdateScreen(id, schoolId) {
      this.currentShopId = id
      this.currentSchoolId = schoolId
      this.dialogScreenKey++
      this.bShowDeivceMangeDialog = true
    },
    exportExcel() {
      const tHeader = [
        '店铺名称',
        '所属省份',
        '所属城市',
        '所属区/县',
        '详细地址',
        '咨询电话',
        '覆盖小学',
        'NAS',
        '版本号',
        '更新时间',
        '连接状态'
      ]
      const filterVal = [
        'name',
        'province_name',
        'city_name',
        'area_name',
        'address',
        'telephone',
        'school_count',
        'local_url',
        'version',
        'modify_time',
        'connect_status'
      ]
      let list = JSON.stringify(this.tableData)
      list = JSON.parse(list)
      list.forEach(e => {
        e.telephone = e.extra.telephone
        e.local_url = e.extra.local_url
        e.version = e.extra.version
        e.connect_status = e.connect_status == '1' ? '连接中' : '未连接'
      })
      Tool.exportExcel(tHeader, filterVal, list, '店铺管理')
    },
    editPrint(shop_id) {
      this.printPostForm.shop_id = shop_id
      this.$http.getPrinterInfo(this.printPostForm).then(res => {
        if (res.data) {
          this.printPostForm = Object.assign(this.printPostForm, res.data)
          this.getPrintList()
        } else {
          this.printPostForm = Object.assign({}, defaultPrintPostForm)
          this.printPostForm.shop_id = shop_id
          this.printLists = []
        }
        this.bShowSettingPrintDialog = true
      })
    },
    getPrintList() {
      this.$http.getPrinterList(this.printPostForm).then(res => {
        res.data.forEach(ele => { ele.name = ele.driver_name; ele.id = ele.driver_name })
        this.printLists = res.data
      })
    },
    bindPrint() {
      this.$http.setPrinterInfo(this.printPostForm).then(res => {
        this.$message.success('操作成功')
        this.bShowSettingPrintDialog = false
      })
    },
    handleEnterSearch(e) { // 回车触发事件
      const keyCode = window.event ? e.keyCode : e.which
      if (keyCode == 13 && this.search.name) {
        this.getShopList()
      }
    },
    fnUpdateCorrectId(row) {
      this.correctPostForm.shop_id = row.id
      this.correctPostForm.node_id = row.node_id || ''
      this.bShowSetCorrectDialog = true
    },
    fnConfirmCorrect() {
      if (!this.correctPostForm.node_id) {
        this.$message.error('请输入节点ID')
        return
      }
      this.$http.setAssistantNode(this.correctPostForm).then(res => {
        this.$message.success('操作成功')
        this.getShopList()
        this.bShowSetCorrectDialog = false
      })
    }
  }
}
</script>
<style lang="scss">
.store-setting {
  .el-form-item__label {
    font-size: 16px;
    color: #333;
  }
  .el-form-item__content {
    margin: 0 20px 0 12px;
  }
  .el-button.el-button-confirm {
    width: 80px !important;
  }
  .el-dialog {
    height: 420px;
    .el-dialog__body {
      height: 340px;
      padding: 10px;
      overflow: auto;
    }
    .el-table tr th {
      background: #fff;
      color: #333;
      font-size: 16px;
      font-weight: bold;
      height: 40px;
      text-align: left;
    }
    .el-table td,
    .el-table th {
      padding: 8px !important;
      text-align: left;
      border: none;
    }
  }
}

</style>
